module.exports = __webpack_public_path__ + "static/withDoctor2-333ef56ebbe56b48878d85523f786d8b.jpg";